import { r as remToPixels } from '../LocalModules/storm-ui-utils/dist/esm/remToPixels-BA_JPFGh-BA_JPFGh.js';

// TODO: When removing v3 Theme, need to update this to just import & use Theme.
// right now having theme.spacing in both v3 and v4 tokens causes a typescript issue.

// eslint-disable-next-line max-len
const getDefaultPopoverSpacing = (isMobile, theme) => remToPixels(isMobile ? theme.spacing.xxsmall.mobile : theme.spacing.xxsmall.default);

export { getDefaultPopoverSpacing as g };
//# sourceMappingURL=utils-Cmlx81uL.js.map
